/**
 * templateEntityTypes — canonical list of entity types that use the generic
 * Template Entity Kit's shared CRDT room. Zero imports, importable by both
 * `gui/` (normal ESM import) and `tool-runtime/` (via `require()`, the same
 * cross-package pattern already used by `entity_add.ts` requiring
 * `gui/src/apps/EntityGraphApp/tools/entity_add.m.ts`).
 *
 * ISOMORPHIC MANIFEST — ships a hand-committed compiled Node artifact,
 * `templateEntityTypes.node.js` (deliberately NOT `.m.js` — see that file's
 * header comment for why a same-stem `.js` sibling breaks gui's Vite/Rollup
 * production build). tool-runtime runs as plain Node in production (no
 * ts-node), so it `require()`s `templateEntityTypes.node`; gui/Vite bundles
 * this `.m.ts` directly. Keep the two in sync — if you edit this file,
 * recompile `templateEntityTypes.node.js` to match.
 *
 * Adding a new generic template-entity type = append its entityType string
 * here. That's it — `localFirstSyncService.ts`, `roomResolver.ts`, and
 * `websocket-server/roomAuth.js` never need to be touched again for it. See
 * `docs/Kernel/Entity System/CRDT_TEMPLATE_ENTITY_SCAFFOLD.md` (Generic
 * Template Entity Kit section) for the full picture.
 */

/** Every generic template-entity type shares this one Y.Doc room prefix. */
export const GENERIC_ENTITY_ROOM_PREFIX = 'template-entity';

/** entityType strings that resolve to the shared `template-entity:<id>` room. */
export const GENERIC_ENTITY_TYPES: readonly string[] = ['Equipment', 'Character'];

export function isGenericTemplateEntityType(entityType: string | undefined | null): boolean {
  if (!entityType) return false;
  return GENERIC_ENTITY_TYPES.includes(entityType);
}
